export default function getYouTubeVideoId(url: string) {
  const matches = (url || "").match(
    /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/live\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&]{10,12})/,
  );

  return matches && matches[1] ? matches[1] : null;
}
